import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG, TransferState } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RepositoryService } from './baseServices/repository.service';
import { StorageService } from './baseServices/storage.service';
import { ShellModule } from './shared/shared/shell/shell.module';
import { TransferStateHelper } from './utils/transfer-state-helper';
import { JwtInterceptor } from './baseServices/jwt.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PrivacyPolicyPageModule } from './pages/privacy-policy/privacy-policy.module';
import { TermsOfServicePageModule } from './pages/terms-of-service/terms-of-service.module';
import { IonicGestureConfig } from './utils/IonicGestureConfig';
import { LocationPermissionRequiredPageModule } from './pages/locationPermissionRequired/location-permission-required.module';
import { TutorialPageModule } from './pages/tutorial/tutorial.module';
import { HttpErrorInterceptor } from './baseServices/http-error.interceptor';
import { SafeHtmlPipe } from './utils/pipes/safe-html.pipe';
import { Media } from '@awesome-cordova-plugins/media/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { SwiperModule } from 'swiper/angular';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { GlobalErrorHandlerService } from './baseServices/logging/global-error-handler.service';
import { TraceparentInterceptor } from './baseServices/logging/traceparent.interceptor';
import { AndroidFullScreen } from '@awesome-cordova-plugins/android-full-screen/ngx';
import { ApiModule } from '@platform/api-client';
import { provideRecoveryTracApi } from '@platform/api-client';
import { environment } from '../environments/environment';

export function initializeIonicStorage(storage: Storage): () => Promise<void> {
  return async () => { await storage.create(); };
}

// Install swiper modules globally
SwiperCore.use([Navigation, Pagination]);
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        ShellModule,
        NgxSpinnerModule,
        PrivacyPolicyPageModule,
        TermsOfServicePageModule,
        TutorialPageModule,
        LocationPermissionRequiredPageModule,
        HammerModule,
        ApiModule,
        IonicStorageModule.forRoot({
            name: '__mydb',
            driverOrder: [Drivers.IndexedDB],
        }),
        SwiperModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: APP_INITIALIZER, multi: true, deps: [Storage], useFactory: initializeIonicStorage },
        AndroidFullScreen,
        Media,
        File,
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        { provide: HTTP_INTERCEPTORS, useClass: TraceparentInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: IonicGestureConfig,
        },
        StorageService,
        RepositoryService,
        TransferStateHelper,
        TransferState,
        DecimalPipe,
        SafeHtmlPipe,
        ...provideRecoveryTracApi(environment.webApiBaseUrl.replace(/\/api$/, '')),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
